<template>
  <div class="wlx-news-backstage-wrappers">
      <header class="u-school-manager-headss">
        <el-form :inline="true" size="small">
          <div class="dd-search-form-news">
            <el-form-item>
              <el-input v-model="cName" placeholder="请输行业组织或者企业名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"  @click="goBack">返回</el-button>
            </el-form-item>
          </div>
        </el-form>
      </header>
      <div class="u-table-mains">
        <el-table
          ref="multipleeeeTable"
          :data="list"
          tooltip-effect="dark"
        >
          <!-- <el-table-column prop="id" type="selection" width="55"></el-table-column> -->
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="industryField" label="行业领域" width="80"></el-table-column>
          <el-table-column prop="companyName" label="行业组织或企业名称" width="150"></el-table-column>
          <el-table-column prop="jobsName" label="岗位名称" width="80"></el-table-column>
          <el-table-column prop="needProvince" label="需求省份" width="60"></el-table-column>
          <el-table-column prop="needNumber" label="需求数量" width="50"></el-table-column>
          <el-table-column prop="newsType" label="岗位学历要求" width="60">
            <template slot-scope="scope">
              <span v-if="scope.row.elevel==1">高职</span>
              <span v-else>中职</span>
            </template>
          </el-table-column>
          <el-table-column label="岗位能力要求" width="300">
            <template slot-scope="scope">
              <p v-html="scope.row.abilityRequirements" class="scope-p"></p>
            </template>
          </el-table-column>
          <el-table-column label="专业要求">
            <template slot-scope="scope">
              <p v-html="scope.row.majorRequirements" class="scope-p"></p>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <p v-html="scope.row.note" class="scope-p"></p>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" ></el-table-column>
        </el-table>
      </div>
      <div class="news-page-con">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      viewNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      industryField: "",
      elevel: 0,
      companyName: "",
      jobsName:"",
      phone:"",
      needProvince:"",
      needNumber:"",
      abilityRequirements:"",
      majorRequirements:"",
      note:"",
      /* --------------------------------------- */
      id: "",
      ids: [],
      cName:"",
      options: [
        {
          label: "高职",
          value: 1
        },
        {
          label: "中职",
          value: 2
        }
      ],
      value: "",
      needJobsId: "",
      urlAliyunOSS: "/api/design/osssign/getsign"
    };
  },
  created() {
    this.getJobsList();
  },
  methods: {
    getJobsList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/JobsNeedAllList/getJobsList", {
          page: page,
          pageSize: this.pageSize,
          cName: that.cName,
          ETyoe: that.value
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
            this.cancel();
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    //返回
    goBack(){
      this.$router.go(-1);
    },
    onPageChangeHandler(page) {
      this.getJobsList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getJobsList();
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.id);
      });
    },
    cancel() {
      (this.addNewNoticeVisible = false),
      (this.editNoticeVisible = false),
      (this.viewNoticeVisible = false),
      this.industryField= "",
      this.elevel= 0,
      this.companyName= "",
      this.jobsName="",
      this.needProvince="",
      this.needNumber="",
      this.abilityRequirements="",
      this.majorRequirements="",
      this.note=""
    },
    addJobs() {
      var that = this;
      this.$http
        .post("/api/XOrg/JobsNeedManager/addJobs", {
          industryField: that.industryField,
          elevel: that.elevel,
          companyName: that.companyName,
          jobsName: that.jobsName,
          needProvince: that.needProvince,
          needNumber: that.needNumber,
          abilityRequirements:that.abilityRequirements,
          majorRequirements:that.majorRequirements,
          note:that.note
        })
        .then(rst => {
          if (rst.code === 1) {
            that.cancel();
            that.$message({
              showClose: true,
              message: rst.msg,
              type: "success"
            });
            that.getJobsList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    viewSchoolNews(row) {
      this.industryField = row.industryField;
      this.elevel = row.elevel;
      this.companyName = row.companyName;
      this.jobsName = row.jobsName;
      this.needProvince = row.needProvince;
      this.needNumber = row.needNumber;
      this.abilityRequirements = row.abilityRequirements;
      this.majorRequirements = row.majorRequirements;
      this.note = row.note;
      this.viewNoticeVisible = true;
    },
    editNeedJobs() {
      var that = this;
      debugger
      this.$http
        .post("/api/XOrg/JobsNeedManager/editJobs", {
          id: that.needJobsId,
          industryField: that.industryField,
          companyName: that.companyName,
          jobsName: that.jobsName,
          needProvince: that.needProvince,
          needNumber: that.needNumber,
          abilityRequirements: that.abilityRequirements,
          majorRequirements: that.majorRequirements,
          note: that.note
        })
        .then(rst => {
          if (rst.code === 1) {
            that.cancel();
            that.$message({
              message: rst.msg,
              type: "success"
            });
            that.editNoticeVisible = false;
            that.getJobsList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    add() {
      this.addNewNoticeVisible = true;
    },
    edit(row) {
      this.editNoticeVisible = true;
      this.industryField = row.industryField;
      this.elevel = row.elevel;
      this.companyName = row.companyName;
      this.needJobsId = row.id;
      this.jobsName = row.jobsName;
      this.needProvince = row.needProvince;
      this.needNumber = row.needNumber;
      this.abilityRequirements = row.abilityRequirements;
      this.majorRequirements = row.majorRequirements;
      this.note = row.note;
    },
    deleteMajor(id) {
      this.$confirm("此操作将删除该岗位信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // this.DeleteSchoolNews(id)
          var that = this;
          this.$http
            .post("/api/XOrg/JobsNeedManager/deleteNews", {
              jobsIds: id
            })
            .then(rst => {
              if (rst.code === 1) {
                that.$message({
                  message: rst.msg,
                  type: "success"
                });
                that.getJobsList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getJobsList(1);
    },
    deleteAll() {
      if (this.ids.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择新闻",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选岗位信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // DeleteSchoolNews(this.ids)
          var that = this;
          this.$http
            .post("/api/XOrg/JobsNeedManager/deleteNews", {
              jobsIds: that.ids
            })
            .then(rst => {
              if (rst.code === 1) {
                this.$message({
                  message: rst.msg,
                  type: "success"
                });
                this.getJobsList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>


<style lang='scss'>
.wlx-news-backstage-wrappers {
  background: #e7ecf4;
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  .u-school-manager-headss{
    text-align: right;
  }
  .news-page-con {
    padding: 20px 0;
    text-align: center;
  }
  .dd-search-form-news{
      // margin: 13px 0px 0 0;
  }
}
</style>
